class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  /*
    Open the cart drawer.

    `announce` carries the message the shopper should hear when the drawer was
    opened by an action rather than by them clicking the cart icon — adding to
    bag, for instance. openMenuDrawer moves focus into the drawer either way.
  */
  open(options = {}) {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      // Already open (a second add-to-bag): focus is in the right place, but
      // the shopper still needs to be told the cart changed.
      if (options.announce) theme.a11y.announce(options.announce);
      return;
    }

    this.drawer.openMenuDrawer(false, {
      opener: this.activeElement || null,
      announce: options.announce,
    });
  }

  renderContents(parsedState, options = {}) {
    this.productId = parsedState.id;
    // Shopify returns no sections when it cannot render them for the requesting
    // URL (an app proxy page, say). The add itself still succeeded, so open the
    // drawer with whatever markup is already on the page rather than throwing
    // and leaving the shopper thinking nothing happened.
    const sections = (parsedState && parsedState.sections) || {};
    this.getSectionsToRender().forEach((section => {
      const target = document.getElementById(section.id);
      if (!target || !sections[section.id]) return;
      target.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
    }));

    this.open({
      announce:
        options.announce ||
        (window.theme && theme.cartStrings && theme.cartStrings.itemAdded) ||
        undefined,
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
